import { render } from "./S74162.vue?vue&type=template&id=50c1586e"
const script = {}
script.render = render

export default script